import axios from "axios";
import LocalStorage from "../../localStorage";
import {loggedOut} from "../auth";

export const GET_DIMENSION_REQUEST = 'GET_DIMENSION_REQUEST';
export const GET_DIMENSION_SUCCESS = 'GET_DIMENSION_SUCCESS';
export const GET_DIMENSION_FAILURE = 'GET_DIMENSION_FAILURE';

const localStorageService = LocalStorage.getService();

export const getDimensionRequest = () => {
    return {type: GET_DIMENSION_REQUEST}
};

export const getDimensionSuccess = (dimension = {}) => {
    return {type: GET_DIMENSION_SUCCESS, dimension}
};

export const getDimensionFailure = (error) => {
    return {type: GET_DIMENSION_FAILURE, error}
};

export const startGetDimension = () => {
    console.log('Start startGetDimension');
    let token = localStorageService.getAccessToken();
    return (dispatch) => {
        dispatch(getDimensionRequest());
        return axios({
                url: `${process.env.REACT_APP_API_ROOTURL}/dimension/list?key=${process.env.REACT_APP_SERVICE_ACCOUNT_KEY}`,
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                    Authorization: 'Bearer ' + token,
                },
                data: JSON.stringify({}),
            }
        )
            .then(function (response) {
                if (response.status === 200 && response.data !== null) {
                    console.log("Response dimension search ", response.data);
                    dispatch(getDimensionSuccess(response.data));

                }
            })
            .catch(function (error) {
                console.log(error);
                if(error.response.status === 401) dispatch(loggedOut());
                dispatch(getDimensionFailure(error));
            });
    };
};
